// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3afti","info":"Note_info__12BlU","note":"Note_note__5-j_3","actions":"Note_actions__1RgfX"};